document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(function(){
    var complementary = document.querySelector('.products-complementary.hide');

    if (complementary !== null) {
      var tab = complementary.closest('.product-block--complementary');
      tab.remove();
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("loyal")) {
        // Redirect to '?loyal' only, discarding other parameters
        const newUrl = `${window.location.pathname}?loyal`;

        // Check if the current URL is already simplified to '?loyal'
        if (window.location.search !== "?loyal") {
            window.location.href = newUrl; // Redirect to '?loyal'
        } else {
            console.log("Already on '?loyal', no further action needed.");
        }
    } else {
        console.log("The 'loyal' parameter is missing. No redirection performed.");
    }
});
